import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Invoice from '../components/Invoice';
import '../components/BookingModalAdmin.css';
import { FaArrowLeft } from 'react-icons/fa';

export default function AdminInvoicePage() {
  const navigate = useNavigate();
  
  // Generate bed options
  const generateBedOptions = () => {
    const beds = [];
    // Room A: A1-A22
    for (let i = 1; i <= 22; i++) {
      beds.push(`A${i}`);
    }
    // Room B: B1-B16
    for (let i = 1; i <= 16; i++) {
      beds.push(`B${i}`);
    }
    return beds;
  };
  
  const bedOptions = generateBedOptions();
  
  const [bookingDetails, setBookingDetails] = useState({
    bookingName: '',
    guestName: '',
    bookingId: '',
    checkInDate: '',
    checkOutDate: '',
    beds: 1,
    nights: 1,
    bedNumbers: [],
    ratePerNight: 699,
    taxRate: 0.05,
    extraCharges: [],
    guests: 1
  });

  const [showInvoice, setShowInvoice] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBookingDetails(prev => ({
      ...prev,
      [name]: name === 'beds' || name === 'nights' || name === 'ratePerNight' || name === 'taxRate' || name === 'guests' 
        ? parseFloat(value) || 0 
        : value
    }));
  };
  
  const handleBedSelection = (e) => {
    const selectedBeds = Array.from(e.target.selectedOptions, option => option.value);
    setBookingDetails(prev => ({
      ...prev,
      bedNumbers: selectedBeds
    }));
  };

  const handleExtraChargeChange = (index, field, value) => {
    const updatedCharges = [...bookingDetails.extraCharges];
    updatedCharges[index] = { ...updatedCharges[index], [field]: value };
    setBookingDetails(prev => ({ ...prev, extraCharges: updatedCharges }));
  };

  const addExtraCharge = () => {
    setBookingDetails(prev => ({
      ...prev,
      extraCharges: [...prev.extraCharges, { label: '', amount: 0 }]
    }));
  };

  const removeExtraCharge = (index) => {
    setBookingDetails(prev => ({
      ...prev,
      extraCharges: prev.extraCharges.filter((_, i) => i !== index)
    }));
  };

  const handleGenerateInvoice = (e) => {
    e.preventDefault();
    setShowInvoice(true);
  };

  const handlePrintInvoice = () => {
    window.print();
  };

  return (
    <>
      <Header />
      <div className="booking-admin-page-container">
        <button className="back-to-dashboard" onClick={() => navigate('/admin/dashboard')} style={{ margin: '18px 0 0 18px', background: 'none', border: 'none', color: '#3f51b5', fontSize: '1.1rem', cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <FaArrowLeft style={{ marginRight: 7 }} /> Back to Dashboard
        </button>
        
        {showInvoice ? (
          <div style={{ padding: '20px' }}>
            <Invoice bookingDetails={bookingDetails} />
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button className="modal-btn modal-btn-primary" onClick={handlePrintInvoice} style={{ marginRight: '10px' }}>
                Print Invoice
              </button>
              <button className="modal-btn modal-btn-secondary" onClick={() => setShowInvoice(false)}>
                Back to Form
              </button>
            </div>
          </div>
        ) : (
          <div className="booking-modal booking-admin-fullpage">
            <div className="modal-content">
              <div className="modal-form-section">
                <div className="modal-title">Generate Invoice</div>
                <form onSubmit={handleGenerateInvoice} className="booking-form">
                  <div>
                    <label htmlFor="bookingName">Booking Name</label>
                    <input 
                      id="bookingName"
                      className="modal-input" 
                      name="bookingName" 
                      value={bookingDetails.bookingName} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="guestName">Guest Name</label>
                    <input 
                      id="guestName"
                      className="modal-input" 
                      name="guestName" 
                      value={bookingDetails.guestName} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="bookingId">Booking ID</label>
                    <input 
                      id="bookingId"
                      className="modal-input" 
                      name="bookingId" 
                      value={bookingDetails.bookingId} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>
                  
                  <div className="modal-row">
                    <div className="modal-col">
                      <label htmlFor="checkInDate">Check-In Date</label>
                      <input 
                        id="checkInDate"
                        className="modal-input" 
                        type="date" 
                        name="checkInDate" 
                        value={bookingDetails.checkInDate} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                    <div className="modal-col">
                      <label htmlFor="checkOutDate">Check-Out Date</label>
                      <input 
                        id="checkOutDate"
                        className="modal-input" 
                        type="date" 
                        name="checkOutDate" 
                        value={bookingDetails.checkOutDate} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                  </div>
                  
                  <div className="modal-row">
                    <div className="modal-col">
                      <label htmlFor="beds">Number of Beds</label>
                      <input 
                        id="beds"
                        className="modal-input" 
                        type="number" 
                        min="1" 
                        name="beds" 
                        value={bookingDetails.beds} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                    <div className="modal-col">
                      <label htmlFor="nights">Number of Nights</label>
                      <input 
                        id="nights"
                        className="modal-input" 
                        type="number" 
                        min="1" 
                        name="nights" 
                        value={bookingDetails.nights} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="bedNumbers">Select Beds</label>
                    <select
                      id="bedNumbers"
                      multiple
                      className="modal-input"
                      style={{ height: '120px' }}
                      value={bookingDetails.bedNumbers}
                      onChange={handleBedSelection}
                    >
                      {bedOptions.map(bed => (
                        <option key={bed} value={bed}>{bed}</option>
                      ))}
                    </select>
                    <div style={{ fontSize: '0.85rem', color: '#6b7280', marginTop: '0.5rem' }}>
                      Hold Ctrl/Cmd to select multiple beds
                    </div>
                  </div>
                  
                  <div className="modal-row">
                    <div className="modal-col">
                      <label htmlFor="ratePerNight">Rate per Night (₹)</label>
                      <input 
                        id="ratePerNight"
                        className="modal-input" 
                        type="number" 
                        min="0" 
                        step="0.01" 
                        name="ratePerNight" 
                        value={bookingDetails.ratePerNight} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                    <div className="modal-col">
                      <label htmlFor="taxRate">Tax Rate</label>
                      <input 
                        id="taxRate"
                        className="modal-input" 
                        type="number" 
                        min="0" 
                        step="0.01" 
                        name="taxRate" 
                        value={bookingDetails.taxRate} 
                        onChange={handleChange} 
                        required 
                      />
                    </div>
                  </div>
                  
                  <div>
                    <label htmlFor="guests">Number of Guests</label>
                    <input 
                      id="guests"
                      className="modal-input" 
                      type="number" 
                      min="1" 
                      name="guests" 
                      value={bookingDetails.guests} 
                      onChange={handleChange} 
                      required 
                    />
                  </div>
                  
                  <div>
                    <label>Extra Charges</label>
                    <div style={{ marginBottom: '0.5rem', fontSize: '0.9rem', color: '#6b7280' }}>
                      Add any additional charges such as towels, laundry, food, etc.
                    </div>
                    {bookingDetails.extraCharges.map((charge, index) => (
                      <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
                        <input
                          type="text"
                          placeholder="Description (e.g. Towel, Laundry)"
                          className="modal-input"
                          style={{ flex: 2 }}
                          value={charge.label}
                          onChange={(e) => handleExtraChargeChange(index, 'label', e.target.value)}
                          required
                        />
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <span style={{ fontWeight: '500' }}>₹</span>
                          <input
                            type="number"
                            placeholder="0.00"
                            className="modal-input"
                            style={{ flex: 1, maxWidth: '120px' }}
                            value={charge.amount}
                            min="0"
                            step="0.01"
                            onChange={(e) => handleExtraChargeChange(index, 'amount', parseFloat(e.target.value) || 0)}
                            required
                          />
                        </div>
                        <button type="button" className="modal-btn modal-btn-secondary" style={{ marginLeft: 2, padding: '0.35rem 0.9rem', fontSize: '0.95rem', height: '2.2rem' }} onClick={() => removeExtraCharge(index)}>
                          Remove
                        </button>
                      </div>
                    ))}
                    <button type="button" className="modal-btn modal-btn-secondary" onClick={addExtraCharge} style={{ marginTop: 4, fontSize: 13, padding: '0.35rem 0.9rem', height: '2.2rem' }}>
                      + Add Extra Charge
                    </button>
                  </div>
                  
                  <div className="modal-actions">
                    <button type="button" className="modal-btn modal-btn-secondary" onClick={() => navigate('/admin/dashboard')}>
                      Cancel
                    </button>
                    <button type="submit" className="modal-btn modal-btn-primary">
                      Generate Invoice
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
